// extracted by mini-css-extract-plugin
export default {"totalsWrapper":"BudgetEditor-module__totalsWrapper___iCm3b","nbView":"BudgetEditor-module__nbView___tRTbQ","textAlignLeft":"BudgetEditor-module__textAlignLeft___M0Hi0"};